import { render, staticRenderFns } from "./mckesson.vue?vue&type=template&id=c21d1d08&scoped=true&v-once=true"
import script from "./mckesson.vue?vue&type=script&lang=js"
export * from "./mckesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21d1d08",
  null
  
)

export default component.exports